import { IAppState } from './contexts/AppReducer'

export const STORAGE_KEY = 'REACT_APP_STORAGE'

export const storage = {
  storage: localStorage,

  setStorage: function (storage: Storage) {
    this.storage = storage
  },

  get: function () {
    const data = this.storage.getItem(STORAGE_KEY)
    if (data) {
      return JSON.parse(data) as IAppState
    }
    return null
  },

  set: function (data: IAppState) {
    this.storage.setItem(STORAGE_KEY, JSON.stringify(data))
  },
}
